(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    // The footer's "suggest a cologne" link arrives as ?reason=Suggestion. Preselect
  // that pill so the visitor does not have to answer a question they already have.
  (() => {
    const wanted = new URLSearchParams(location.search).get('reason');
    if (!wanted) return;
    const target = [...document.querySelectorAll('[data-contact-reason]')].find(
      (input) => input.value.toLowerCase() === wanted.toLowerCase()
    );
    if (target) target.checked = true;
  })();
  } catch(e) { console.error(e); }
})();

})();
